module.exports = __webpack_public_path__ + "img/img_web_02_feature1.caa7ae16.png";